import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks, BodyScrollOptions } from 'body-scroll-lock';

var hamburger = {
    selector: '.hamburger',
    init: function() {
        var self = this,
            $hamburger = jQuery( self.selector + ', .navigation__bgMobile' ),
            $navigation = jQuery( '.navigation' );

        var navigation = document.querySelector( '.navigation__container' );

       jQuery( document ).on('click', self.selector + ', .navigation__bgMobile', function (e) {
            $navigation.addClass( 'navigation--animate' );
            jQuery( 'html' ).toggleClass( 'navigation-opened' );

            if ( jQuery( 'html' ).hasClass( 'navigation-opened' ) ) {

                const  focusableElements = 'button, [href]:not(.branding__logo), input, select, textarea, [tabindex]:not([tabindex="-1"])';
                let header_navigation = document.querySelector('#site-header'); // select the header_navigation by it's id
                
                const firstFocusableElement = header_navigation.querySelectorAll(focusableElements)[0]; // get first element to be focused inside header_navigation
                const focusableContent = header_navigation.querySelectorAll(focusableElements);
                const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside header_navigation
        
        
                document.addEventListener('keydown', function(e) {
                    let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
        
                    if (!isTabPressed) {
                        return;
                    }
        
                    if (e.shiftKey) { 
						// if shift key pressed for shift + tab combination

                        if (document.activeElement === firstFocusableElement) {
                        	lastFocusableElement.focus(); // add focus for the last focusable element
                        	e.preventDefault();
                        }
                    } else { // if tab key is pressed
                        if (document.activeElement === lastFocusableElement) { 
							// if focused has reached to last focusable element then focus first focusable element after pressing tab
                        	firstFocusableElement.focus(); // add focus for the first focusable element
                        	e.preventDefault();
                        }
                    }
                });
        
                firstFocusableElement.focus();  


            } else {
                document.querySelector( '.branding__logo' ).focus();
            }
        } );


        //jQuery('.submenu-toggle').on( 'click', function( e ) {
        jQuery( document ).on('click', '.submenu-toggle', function (e) {
            jQuery(this).parent().children('ul').slideToggle('fast');
            jQuery(this).next('ul').addClass('active');
            jQuery(this).toggleClass('active');

        } );
        
        /*
        jQuery( window ).on( 'resize', function( e ) {
            $navigation.removeClass( 'navigation--animate' );
            jQuery( document.body ).removeClass( 'navigation-opened' );
            enableBodyScroll( navigation );
        } );
        */

        jQuery( document ).on('click','.navigation a', function (e) {
            jQuery( 'html' ).removeClass( 'navigation-opened' );
            enableBodyScroll( navigation );
        } );
    }
}

export {
    hamburger
};
